'use strict';
var angular = require('angular');
var GeneralInfoEditController = /** @class */ (function () {
    /*@ngInject*/
    function GeneralInfoEditController(Auth, $state, Util, $cookies, $scope, $mdToast, UserService, GeneralInfoEditService, SettingsService) {
        var _this = this;
        this.titles = ['', 'Dr.', 'Miss', 'Mr.', 'Ms.', 'Mrs.'];
        this.professionalDesignations = ['', 'MD', 'DC', 'LMT'];
        this.suffixes = ['', 'II', 'III', 'IV', 'V', 'VI', 'Jr.', 'Sr.', 'Esq.'];
        this.accountFinishedLoading = false;
        this.defaultCountry = 'US';
        this.searchText = null;
        this.enteredRegion = null;
        this.cpid = null;
        this.postalCodePattern = "";
        this.passwordChanged = false;
        this.updateFlag = true;
        // phonePattern = new RegExp('^(\\d{3})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
        this.phonePattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
        this.maxPhoneLength = 12;
        this.phonePlaceholder = 'xxx-xxx-xxxx';
        this.miPattern = new RegExp('[a-zA-Z]');
        this.errors = {
            havePageErrors: false,
            pageErrors: '',
            pageErrorType: ''
        };
        //this.audience = UserService.getAudience();
        this.generalInfo = GeneralInfoEditService;
        this.$scope = $scope;
        this.$cookies = $cookies;
        this.Auth = Auth;
        this.$mdToast = $mdToast;
        this.Util = Util;
        this.settingsService = SettingsService;
        this.emailCheckSubscription = {};
        this.isImpersonated = false;
        var self = this;
        self.settingsService.getAccount().then(function (newAccount) {
            self.isImpersonated = newAccount.isImpersonated;
        })
            .catch(function (flag) {
            self.isImpersonated = false;
        });
        Auth.getCurrentUser()
            .then(function (resp) { return self.loggedInUser = resp; })
            .catch(function () {
            _this.errors.havePageErrors = true;
            _this.pageErrors = 'User not found';
            _this.showAlert = true;
        })
            .finally(function () { return self.accountFinishedLoading = true; });
        // TODO: Have a look at what this is doing. Currently it's never being run.
        if (self.user && self.user.country) {
            self.postalCodePattern = "/" + self.user.country.postalCodeRegex + "/";
            if (self.user.country.countryCode == 'US') {
                self.phonePattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
                self.maxPhoneLength = 12;
                self.phonePlaceholder = 'xxx-xxx-xxxx';
            }
            else {
                self.phonePattern = new RegExp('^(\\d)(?!\\1+$)\\d{9,13}$');
                self.maxPhoneLength = 14;
            }
        }
        self.cpid = this.$cookies.get('cpid');
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            if (self.states.length <= 0) {
                self.user.state = { regionCode: self.enteredRegion, regionName: self.enteredRegion };
            }
            self.onUpdate({
                $event: {
                    user: self.user
                }
            });
        });
        $scope.$watch('$viewContentLoaded', function (event) {
            $scope.$watch('gi.accountForm.$valid', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    $scope.$emit('accountFormValid', newVal);
                }
            });
        });
        $scope.$on('countryUpdated', function (event, data) {
            if (data.countryCode == 'US') {
                self.phonePattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
                self.maxPhoneLength = 12;
                self.phonePlaceholder = 'xxx-xxx-xxxx';
            }
            else {
                self.phonePattern = new RegExp('^(\\d)(?!\\1+$)\\d{9,13}$');
                self.maxPhoneLength = 14;
            }
        });
        $scope.$on('addressAPIError', function (event, data) {
            self.errors = data;
        });
    }
    GeneralInfoEditController.prototype.$onDestroy = function () {
        if (this.emailCheckSubscription && this.emailCheckSubscription.hasOwnProperty('unsubscribe')) {
            this.emailCheckSubscription.unsubscribe();
        }
    };
    // This is to ensure that any changes to our local user object don't reflect in
    // the parent object that was passed to us.
    GeneralInfoEditController.prototype.$onChanges = function (changes) {
        if (changes.user) {
            this.user = angular.copy(this.user);
        }
    };
    GeneralInfoEditController.prototype.checkEmail = function (fieldName, newVal, oldVal, form) {
        var self = this;
        self.settingsService.isFormPristine = form.$pristine;
        if (newVal != oldVal) {
            self.settingsService.isGinfoFormValid = false;
            if (this.user.email && this.user.email !== '') {
                self.settingsService.isGinfoFormValid = this.loggedInUser;
                if (!this.loggedInUser) {
                    self.accountForm.email.$error.loggedInUserError = true;
                    self.accountForm.$setValidity('loggedInUserError', false);
                    return false;
                }
                else {
                    self.accountForm.email.$error.loggedInUserError = false;
                    self.accountForm.$setValidity('loggedInUserError', true);
                }
                if (this.user.email != this.loggedInUser.email) {
                    this.emailCheckSubscription = this.Auth.checkPlatormForEmail(this.user.email).subscribe(function (isEmailInUse) {
                        if (isEmailInUse) {
                            self.settingsService.isGinfoFormValid = false;
                            self.accountForm.email.$error.accountExistsError = true;
                            self.accountForm.$setValidity('accountExists', false);
                            return false;
                        }
                        else {
                            self.settingsService.isGinfoFormValid = true;
                            self.accountForm.email.$error.accountExistsError = false;
                            self.accountForm.$setValidity('accountExists', true);
                            self.accountForm.$setValidity('email', true);
                            self.updateChange('email', newVal, 'Email');
                            return true;
                        }
                    });
                }
                else {
                    self.accountForm.$setValidity('email', true);
                    self.settingsService.isGinfoFormValid = true;
                    return true;
                }
            }
        }
    };
    GeneralInfoEditController.prototype.checkExistingPassword = function (fieldName, newVal, oldVal) {
        var self = this;
        if (!self.accountForm.existingPassword.$valid) {
            self.settingsService.isGinfoFormValid = false;
        }
        if (this.existingPassword && this.existingPassword !== '') {
            self.generalInfo.isValidPassword(self.existingPassword).then(function (isValid) {
                if (isValid) {
                    //preventing making the general info form valid/invalid unnecessarily
                    self.settingsService.isGinfoFormValid = true;
                    self.accountForm.existingPassword.$setValidity('wrongPassword', true);
                }
                else {
                    self.settingsService.isGinfoFormValid = false;
                    self.accountForm.existingPassword.$setValidity('wrongPassword', false);
                }
            });
        }
    };
    GeneralInfoEditController.prototype.checkPassword = function () {
        var self = this;
        if (self.accountForm.existingPassword.$valid &&
            self.user.password == self.existingPassword) {
            self.settingsService.isGinfoFormValid = false;
            self.accountForm.password.$setValidity('existingPasswordMatch', false);
        }
        else if (self.user.password !== self.user.verifyPassword) { //missing condition added.
            self.settingsService.isGinfoFormValid = false;
            self.accountForm.password.$setValidity('existingPasswordMatch', true);
        }
        else if (!self.accountForm.password.$valid) {
            self.settingsService.isGinfoFormValid = false;
        }
        else {
            self.settingsService.isGinfoFormValid = true;
            self.accountForm.password.$setValidity('existingPasswordMatch', true);
        }
    };
    GeneralInfoEditController.prototype.updateChange = function (fieldName, newVal, displayName) {
        var self = this;
        var newAccount = {};
        if (fieldName == 'phoneNumber') {
            if (this.user.phone) {
                this.user.phone = this.user.phone.replace(/[\s-.\/]/g, "");
            }
        }
        newAccount.businessName = this.user.businessName == null ? "" : this.user.businessName;
        newAccount.email = this.isImpersonated ? (this.user.email == null ? "" : this.user.email) : self.settingsService.pinfoUser.email; //only impersonated users can update email address for now
        newAccount.phoneNumber = this.user.phone == null ? "" : this.user.phone;
        newAccount.phoneNumberExt = this.user.ext == null ? "" : this.user.ext;
        newAccount.faxNumber = this.user.fax == null ? "" : this.user.fax;
        newAccount.firstName = this.user.firstName == null ? "" : this.user.firstName;
        newAccount.middleInitial = this.user.middleInitial == null ? "" : this.user.middleInitial;
        newAccount.lastName = this.user.lastName == null ? "" : this.user.lastName;
        newAccount.title = this.user.title == null ? "" : this.user.title;
        newAccount.suffix = this.user.suffix == null ? "" : this.user.suffix;
        newAccount.professionalDesignations = this.user.designation == null ? "" : this.user.designation;
        if (this.user.password != undefined && this.user.password != null && this.user.password != "") {
            self.passwordChanged = false;
            if (self.user.password != self.user.verifyPassword) {
                self.accountForm.verifyPassword.$setValidity('passwordMatchError', false);
                //make the general info form invalid if passwords do not match.
                self.settingsService.isGinfoFormValid = false;
            }
            else if (self.user.password == self.existingPassword) {
                self.accountForm.verifyPassword.$setValidity('existingPasswordMatch', false);
            }
            else {
                self.accountForm.verifyPassword.$setValidity('existingPasswordMatch', true);
                if (self.accountForm.existingPassword.$valid) {
                    self.accountForm.verifyPassword.$setValidity('existingPasswordError', true);
                    self.accountForm.verifyPassword.$setValidity('passwordMatchError', true);
                    newAccount.password = self.user.password;
                    if (self.changeAccountInfo) {
                        this.settingsService.ginfoCustomerId = self.user.customerId;
                        this.settingsService.ginfoNewAccount = newAccount;
                    }
                    else {
                        self.generalInfo.updateAccount(self.user.customerId, newAccount).then(function (response) {
                            if (response.status != 200 || response.data.errors.length) {
                                self.Util.handleApiError(response, self);
                            }
                            else {
                                console.debug('After updating account, response is...', response);
                                self.passwordChanged = true;
                                self.existingPassword = null;
                                self.user.password = null;
                                self.user.verifyPassword = null;
                                self.accountForm.password.$setPristine();
                                self.accountForm.existingPassword.$setPristine();
                                self.accountForm.verifyPassword.$setPristine();
                                self.accountForm.password.$setUntouched();
                                self.accountForm.existingPassword.$setUntouched();
                                self.accountForm.verifyPassword.$setUntouched();
                                self.Util.resetApiError(self);
                                self.showSimpleToast(displayName + " Updated", '');
                            }
                        });
                    }
                }
                else {
                    if (!self.accountForm.existingPassword.$dirty) {
                        self.accountForm.verifyPassword.$setValidity('existingPasswordError', false);
                    }
                }
            }
        }
        else {
            if (self.changeAccountInfo) {
                this.settingsService.ginfoCustomerId = self.user.customerId;
                this.settingsService.ginfoNewAccount = newAccount;
            }
            else {
                self.generalInfo.updateAccount(self.user.customerId, newAccount).then(function (response) {
                    if (response.status != 200 || response.data.errors.length) {
                        self.Util.handleApiError(response, self);
                    }
                    else {
                        console.debug('After updating account, response is...', response);
                        if (fieldName == 'email') {
                            self.Auth.refreshToken(); //@TODO : When refreshToken works with auth/ares
                            self.user = response.data.response;
                        }
                        self.Util.resetApiError(self);
                        self.showSimpleToast(displayName + " Updated", '');
                    }
                });
            }
        }
    };
    GeneralInfoEditController.prototype.isValid = function (form) {
        this.checkFormFieldsForValidityAndClearErrors();
        this.settingsService.isFormPristine = form.$pristine;
        if (form.$valid) {
            return true;
        }
        else {
            return false;
        }
    };
    GeneralInfoEditController.prototype.checkFormFieldsForValidityAndClearErrors = function () {
        this.settingsService.isGinfoFormValid = this.checkAllFormFieldsForValidity();
        this.checkClearVerify();
        this.clearPasswordErrorsIfNecessary();
    };
    GeneralInfoEditController.prototype.clearPasswordErrorsIfNecessary = function () {
        if (!this.accountForm.password.$viewValue &&
            !this.accountForm.existingPassword.$viewValue &&
            !this.accountForm.verifyPassword.$viewValue) {
            this.accountForm.password.$setPristine();
            this.accountForm.existingPassword.$setPristine();
            this.accountForm.verifyPassword.$setPristine();
            this.accountForm.password.$setUntouched();
            this.accountForm.existingPassword.$setUntouched();
            this.accountForm.verifyPassword.$setUntouched();
            this.accountForm.verifyPassword.$setValidity('passwordMatchError', true);
            this.accountForm.verifyPassword.$setValidity('existingPasswordError', true);
            this.accountForm.verifyPassword.$setValidity('existingPasswordMatch', true);
            this.accountForm.verifyPassword.$setValidity('required', true);
            this.accountForm.verifyPassword.$setValidity('minlength', true);
            this.accountForm.password.$setValidity('minlength', true);
            this.accountForm.password.$setValidity('pattern', true);
            this.accountForm.password.$setValidity('existingPasswordMatch', true);
            this.accountForm.password.$setValidity('required', true);
            this.accountForm.existingPassword.$setValidity('required', true);
            this.accountForm.existingPassword.$setValidity('wrongPassword', true);
        }
    };
    GeneralInfoEditController.prototype.checkClearVerify = function () {
        if (!this.accountForm.password.$viewValue &&
            !this.accountForm.existingPassword.$viewValue) {
            this.accountForm.verifyPassword.$setPristine();
            this.accountForm.verifyPassword.$setUntouched();
            this.user.verifyPassword = "";
        }
    };
    GeneralInfoEditController.prototype.checkAllFormFieldsForValidity = function () {
        var areAllElementsValid = true;
        angular.forEach(this.accountForm, function (value, key) {
            if (angular.isObject(value) && value.hasOwnProperty('$modelValue')) {
                if (Object.keys(value.$error).length > 0) {
                    angular.forEach(value.$error, function (errorValue, errorKey) {
                        if (errorValue === true) {
                            areAllElementsValid = false;
                            return;
                        }
                    });
                }
            }
        });
        return areAllElementsValid;
    };
    GeneralInfoEditController.prototype.showSimpleToast = function (message, addMsg) {
        var msg = (addMsg != null) ? addMsg : '';
        this.$mdToast.show(this.$mdToast.simple()
            .textContent(message + ' \n' + msg)
            .parent(document.querySelectorAll('#info-toast'))
            .position('top right')
            .hideDelay(2000));
    };
    //.parent(document.querySelectorAll('#toast'))
    GeneralInfoEditController.prototype.resetPasswordErrors = function () {
        this.accountForm.verifyPassword.$setValidity('passwordMatchError', true);
        this.accountForm.verifyPassword.$setValidity('existingPasswordError', true);
        this.accountForm.verifyPassword.$setValidity('existingPasswordMatch', true);
    };
    return GeneralInfoEditController;
}());
export default GeneralInfoEditController;
//# sourceMappingURL=general-info-edit.controller.js.map